import { EdicionesI } from 'src/app/interfaces/ambiente.interface';
import { LobI } from 'src/app/interfaces/lob.interface';
import { SectorI } from 'src/app/interfaces/segment-sector.interface';
import { UserI } from 'src/app/interfaces/user.interface';

export enum KmType {
  km = 'KM',
  frenadas = 'Frenadas',
}

export interface KmShellI {
  id?: number;
  type: KmType;
  period: Date;
  value: number[];
  createdAt?: Date;
  active: boolean;
  sectors: KmShellSectorI[];
  lob: LobI;
  user: UserI;
  ediciones?: EdicionesI[];
}

export interface KmShellSectorI {
  id?: number;
  value: number[];
  sector: SectorI;
  km?: KmShellI;
}
